var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-base',{attrs:{"pacifier":false},scopedSlots:_vm._u([{key:"title",fn:function(){return [_vm._v("Call Failed")]},proxy:true},{key:"subtitle",fn:function(){return [_vm._v("Please re-enter your phone number:")]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }